import React, { useState, useEffect } from "react";
import { Table, Container, Input, Row, Col, Button, Form, Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';
import Swal from "sweetalert2";
import './ProposalStyle.css'
import pdfFonts from "pdfmake/build/vfs_fonts";
import pdfMake from "pdfmake/build/pdfmake";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export function Report63Component() {

    const [Re63data, setRe63data] = useState([]);

    pdfMake.fonts = {
        THSarabunNew: {
            normal: 'THSarabunNew.ttf',
            bold: 'THSarabunNew Bold.ttf',
            italics: 'THSarabunNew Italic.ttf',
            bolditalics: 'THSarabunNewn BoldItalic.ttf'
        },
        Roboto: {
            normal: 'Roboto-Regular.ttf',
            bold: 'Roboto-Medium.ttf',
            italics: 'Roboto-Italic.ttf',
            bolditalics: 'Roboto-MediumItalic.ttf'
        }
    }
    const [fileInput, setFileInput] = useState(null)
    // console.log("fileInput", fileInput)

    const [fileError, setFileError] = useState(null);
    const [openModalFileForm, setOpenModalFileForm] = useState(false);
    const modalFileToggle = () => setOpenModalFileForm(!openModalFileForm);

    useEffect(() => {
        getR63()
    }, [])

    async function getR63() {
        const res63 = await fetch("/api/Support/getR63")
        const Re63data = await res63.json()
        setRe63data(Re63data.dataenum);
        // console.log(Re63data)
    }

    let namesArr = {};
    const rowSpan = Re63data.reduce((result, item, key) => {
        if (namesArr[item.deptName] === undefined) {
            namesArr[item.deptName] = key;
            result[key] = 1;
        } else {
            const firstIndex = namesArr[item.deptName];
            if (
                firstIndex === key - 1 ||
                (item.deptName === Re63data[key - 1].name && result[key - 1] === 0)
            ) {
                result[firstIndex]++;
                result[key] = 0;
            } else {
                result[key] = 1;
                namesArr[item.deptName] = key;
            }
        }
        return result;
    }, []);


    const importFileSubmit = async (e) => {
        e.preventDefault();
        if (fileInput) {
            let postData = new FormData()
            postData.append("file", fileInput)
            let res = await fetch("api/SupportReports/importExcelReport63", {
                method: "POST",
                body: postData
            })
            let resJson = await res.json()
            if (resJson.status === 1) {
                Swal.fire({
                    icon: "success",
                    title: "นำเข้าข้อมูลสำเร็จ",
                    text: "",
                    confirmButtonColor: "#0A66C2",
                    confirmButtonText: "ตกลง",
                })
            } else {
                Swal.fire({
                    icon: "error",
                    title: "นำเข้าข้อมูลไม่สำเร็จ",
                    text: `เนื่องจาก ${resJson.message}`,
                    confirmButtonColor: "#0A66C2",
                    confirmButtonText: "ตกลง",
                });
            }
        }
        else {
            Swal.fire({
                icon: "info",
                title: "กรุณาแนบไฟล์",
                text: "",
                confirmButtonColor: "#0A66C2",
                confirmButtonText: "ตกลง",
            })
        }
    }

    const handleFileInputChange = (e) => {
        const file = e.target.files[0];
        const allowedTypes = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
        const maxSize = 10000000; // 10 MB

        if (file && !allowedTypes.includes(file.type)) {
            setFileError('รองรับเฉพาะไฟล์ excel');
            setFileInput(null);
        } else if (file && file.size > maxSize) {
            setFileError('ขนาดไฟล์ต้องไม่เกิน 10 MB');
            setFileInput(null);
        } else {
            setFileError(null);
            setFileInput(file);
        }

    }

    const PrintPDF = () => {
        var tablebody = [[{ text: 'ที่', rowSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'หน่วยงาน', rowSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'เลขที่คำขอ', rowSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'คำขอทั้งหมด', rowSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ชื่อศูนย์ทดสอบมาตรฐานฝีมือแรงงาน/ศูนย์ประเมืนความรู้ความสามารถ', rowSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ครั้ง', rowSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'สาขา(จำนวน)', rowSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ศูนย์ทดสอบมาตรฐานฝีมือแรงงาน (ข้อ 11)', colSpan: 4, fillColor: '#cccccc', bold: true, alignment: 'center' }, {}, {}, {}, { text: 'จำนวนเงินช่วยเหลือหรืออุดหนุน (บาท)', rowSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }],
        [{}, {}, {}, {}, {}, {}, {}, { text: 'สาขาอาชีพ', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'สาขา', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'จำนวนผู้เข้ารับการทดสอบฯ (คน)', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'จำนวนเงินค่าทดสอบที่ส่งเข้ากองทุน (บาท)', fillColor: '#cccccc', bold: true, alignment: 'center' }, {}]];
        Re63data.forEach(function (item, i) {
            var rowdata = [{ text: i + 1, alignment: 'center' }, { text: item.deptName, alignment: 'left' }, { text: item.supportNo, alignment: 'right' }, { text: item.supportCount, alignment: 'right' }, { text: item.locationName, alignment: 'left' }, { text: item.time, alignment: 'right' }, { text: item.lawOcc, alignment: 'right' }, { text: item.testLawOccupation, alignment: 'left' }, { text: item.testOccupation, alignment: 'left' }, { text: item.personTotal, alignment: 'right' }, { text: item.amountTotal, alignment: 'right' }, { text: item.paymentAmount, alignment: 'right' }]
            tablebody.push(rowdata);
        });
        var docDefinition = {
            pageOrientation: 'landscape',

            content: [
                { text: 'การอนุมัติให้เงินช่วยเหลือหรืออุดหนุนกองทุนพัฒนาฝีมือแรงงาน ปีงบประมาณ พ.ศ. 2564', style: 'header', alignment: 'center', bold: true, fontSize: 20 },
                // { text: 'ปีงบประมาณ พ.ศ.', style: 'header', bold: true, alignment: 'center', fontSize: 16 },
                [{
                    table: {
                        widths: ['auto', 'auto', 'auto', 40, 60, 40, 63, 63, 63, 63, 63, 63],
                        body: tablebody
                    },
                }]],

            defaultStyle: {
                font: 'THSarabunNew'
            }

        }
        pdfMake.createPdf(docDefinition).download('R63')
    }

    return (
        <Container>
            <div>
                <Form
                    onSubmit={importFileSubmit}
                >
                    <Modal
                        isOpen={openModalFileForm}
                        toggle={modalFileToggle}
                        centered
                        backdrop={"static"}
                        keyboard={false}
                    >
                        <ModalHeader toggle={modalFileToggle}>นำเข้าข้อมูลรายงาน</ModalHeader>
                        <ModalBody>
                            <Input
                                type="file"
                                id="fileInput"
                                onChange={handleFileInputChange}
                            >
                            </Input>
                            {fileError && <span className="text-danger">{fileError}</span>}
                            <ModalFooter>
                                <button className="btn border-1 border" type="submit" onClick={(e) => { importFileSubmit(e) }}>ยืนยัน</button>
                                <button className="btn border-1 border" type="button" onClick={() => modalFileToggle(!openModalFileForm)}>ยกเลิก</button>
                            </ModalFooter>

                            {/* 
                            <ModalFooter>
                                <button className="btn border-1 border" type="submit">ยืนยัน</button>
                                <button className="btn border-1 border" type="button" onClick={modalFileToggle(!openModalFileForm)}>ยกเลิก</button>
                            </ModalFooter> */}
                        </ModalBody>
                    </Modal>
                </Form>

                <h3 className='text-center'>
                    {/*การอนุมัติให้เงินช่วยเหลือหรืออุดหนุนกองทุนพัฒนาฝีมือแรงงาน ปีงบประมาณ พ.ศ. 2564*/}
                </h3>
                <Row>
                    <Col className='d-flex justify-content-end'>
                        {/*<Button href={`api/Support/xlsxR63`} download>.EXCEL</Button>*/}
                        {/*<Button onClick={PrintPDF}>.PDF</Button>*/}
                        {/*<Button >.PDF</Button>*/}
                        <button
                            type="button"
                            className="btn border border-1"
                            onClick={() => { modalFileToggle(!openModalFileForm) }}
                        >
                            นำเข้าข้อมูลรายงาน
                        </button>
                    </Col>
                </Row>
                <div className="outer-wrapper">
                    <div className="table-wrapper">
                        <Table
                            bordered
                            hover
                            responsive
                            className="report-table"
                            style={{
                                minWidth: "3000px",
                            }}>
                            <thead>
                                <tr>
                                    {/*<th rowSpan="2">*/}
                                    {/*    ที่*/}
                                    {/*</th>*/}
                                    <th rowSpan="2" className='text-center'>
                                        หน่วยงาน
                                    </th>
                                    <th rowSpan="2" className=' text-center'>
                                        เลขที่ตำขอ
                                    </th>
                                    <th rowSpan="2" className=' text-center'>
                                        คำขอทั้งหมด
                                    </th>
                                    <th rowSpan="2">
                                        ชื่อศูนย์ทดสอบมาตรฐานฝีมือแรงงาน/ศูนย์ประเมืนความรู้ความสามารถ
                                    </th>
                                    <th rowSpan="2" className='text-center'>
                                        ครั้ง
                                    </th>
                                    <th rowSpan="2" className=' text-center'>
                                        สาขา (จำนวน)
                                    </th>
                                    <th rowSpan="1" colSpan="4" className=' text-center'>
                                        ศูนย์ทดสอบมาตรฐานฝีมือแรงงาน (ข้อ 11)
                                    </th>
                                    <th rowSpan="2" className=' text-center'>
                                        จำนวนเงินช่วยเหลือหรืออุดหนุน (บาท)
                                    </th>
                                </tr>
                                <tr>
                                    <th rowSpan="1" className='text-center'>
                                        สาขาอาชีพ
                                    </th>
                                    <th rowSpan="1" className='text-center'>
                                        สาขา
                                    </th>
                                    <th rowSpan="1" className='text-center'>
                                        จำนวนผู้เข้ารับการทดสอบฯ (คน)
                                    </th>
                                    <th rowSpan="1" className='text-center'>
                                        จำนวนเงินค่าทดสอบที่ส่งเข้ากองทุน (บาท)
                                    </th>

                                </tr>


                            </thead>

                            <tbody>

                                {Re63data?.map((item, i) => (
                                    <tr >
                                        {/*<td  className='text-center'>*/}
                                        {/*    {i + 1}*/}
                                        {/*</td>*/}
                                        {rowSpan[i] > 0 && <td rowSpan={rowSpan[i]} className='text-center'>{item.deptName}</td>}
                                        {/*<td  className='text-start'>*/}
                                        {/*    {item.deptName}*/}
                                        {/*</td>*/}
                                        <td className='text-end'>
                                            {item.supportNo}
                                        </td>
                                        <td className='text-end'>
                                            {item.supportCount}
                                        </td>
                                        <td className='text-start'>
                                            {item.locationName}
                                        </td>
                                        <td className='text-end'>
                                            {item.time}
                                        </td>

                                        <td className='text-end'>
                                            {item.lawOcc}
                                        </td>
                                        <td className='text-start'>
                                            {item.testLawOccupation}
                                        </td>
                                        <td className='text-start'>
                                            {item.testOccupation}
                                        </td>
                                        <td className='text-end'>
                                            {item.personTotal}
                                        </td>
                                        <td className='text-end'>
                                            {item.amountTotal}
                                        </td>
                                        <td className='text-end'>
                                            {item.paymentAmount}
                                        </td>
                                    </tr>
                                )) || <tr><td colSpan="12" className='text-center'>No Data</td></tr>}


                            </tbody>

                        </Table>
                    </div>
                </div>
            </div>

        </Container>


    )
}